module.exports = __webpack_public_path__ + "img/icon_sportMenu_football.3ef5fa49.svg";